const { default: axios } = require('axios');

export async function get(url) {
    return axios.get(url);
}

export async function post(url, requestData) {
    return axios.post(url, requestData);
}
